(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(httpConfig);
    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider', 'ENV'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider, ENV) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        $httpProvider.interceptors.push(['$q', function ($q) {
            const baseUrl = ENV.API_BASE_URL; // Define your base URL here
            return {
                'request': function (config) {
                    // Prepend base URL if it's a relative path
                    if (config.url.startsWith(ENV.API_BASE_URL)) return config;
                    if (config.url.startsWith('api/')) config.url = baseUrl + config.url;
                    return config;
                },
                'responseError':

                    function (rejection) {
                        return $q.reject(rejection);
                    }
            };
        }]);
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name: 'boolean',
            decode: function (val) {
                return val === true || val === 'true';
            },
            encode: function (val) {
                return val ? 1 : 0;
            },
            equals: function (a, b) {
                return this.is(a) && a === b;
            },
            is: function (val) {
                return [true, false, 0, 1].indexOf(val) >= 0;
            },
            pattern: /bool|true|0|1/
        });
    }

})();
